export const GRAPH_NODE_MIN_WIDTH = 200;

export const GRAPH_NODE_MAX_WIDTH = 450;

export const GRAPH_NODE_HEIGHT = 74;

export const RESTRICTED_NODE_HEIGHT = 52;

export const GRAPH_NODE_CHILDREN_HEADER_HEIGHT = 38;

export const GRAPH_PARENT_NODE_HEIGHT =
  GRAPH_NODE_HEIGHT + GRAPH_NODE_CHILDREN_HEADER_HEIGHT;

export const GRAPH_CHILD_NODE_HEIGHT = 40;

export const GRAPH_NODE_VERTICAL_SPACING = 50;

export const GRAPH_NODE_HORIZONTAL_SPACING = 130;

export const GRAPH_CHILD_NODE_VERTICAL_SPACING = 20;

export const GRAPH_NODE_SEARCH_AREA_HEIGHT = 60;

export const CHILD_NODE_PADDING = 8;

export const NODE_DEFAULT_Z_INDEX = 10002;

export const MAX_GRAPH_NODES_WARNING = 1350;
export const MAX_GRAPH_EDGES_WARNING = 3900;
export const LINEAGE_PER_PARENT_COLUMNS_LIMIT = 300;

export const COLLECT_JOB_DATA_DOCS_URL =
  'https://docs.elementary-data.com/deployment-and-configuration/collect-job-data';
